import { Subject } from "rxjs/internal/Subject";
import { N2PdfViewerModel } from "./pdf-viewer.model";

export class N2BlobReference {
  subject = new Subject<N2PdfViewerModel>();
  response = this.subject.asObservable();
}

let n2BlobRef = new N2BlobReference();

export const BlobService = (blob?: N2BlobReference): N2BlobReference => {
  if (blob) n2BlobRef = blob;
  return n2BlobRef;
};
